import SVG from 'react-inlinesvg';
import styles from './index.module.scss';

interface PromotionCarouselPrevButtonProps {
  onClick: () => void;
}

export const PromotionCarouselPrevButton = ({
  onClick,
}: PromotionCarouselPrevButtonProps) => {
  return (
    <button
      className={`${styles['icon-container']} ${styles['prev-icon-container']}`}
    >
      <SVG src="/assets/chevron-left-filled.svg" onClick={onClick} />
    </button>
  );
};
